export const notificationTickerStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  position: "fixed",
  top: 0,
  p: "10px 25px",
};
